import { Trans } from '@lingui/macro';
import React from 'react';
import '../common/global.css';
import logoImg from '../img/luat-hn/luathn_logo.svg';
import BackgroundImg from '../img/luat-hn/luathn-bg.jpg';
import { getRedirectUri } from '../util/ChangeLanguage';

const AuthLayoutSignup = ({ children }) => {
  return (
    <div
      className={
        'min-h-screen min-w-full bg-no-repeat bg-cover bg-center bg-bottom flex text-luat_HN_color '
      }
      style={{ backgroundImage: `url('  ${BackgroundImg}  ')` }}
    >
      <div className="min-w-[50%]">
        <div className="w-fit pl-[80px]">
          <a
            href={getRedirectUri()}
            className="div-logo w-fit flex items-center text-[25px] mt-[140px] mb-[25px]"
          >
            <img src={logoImg} />
            <div className=" text-[25px] font-bold ml-[10px]">
              <h2 className="text-luat_HN_text_red">
                ĐOÀN LUẬT SƯ THÀNH PHỐ HÀ NỘI
              </h2>
              <h2 className="text-luat_HN_text_blue_color text-center text-[18px]">
                <span className="mr-[4px]">HANOI</span>{' '}
                <span className="mr-[4px]">BAR</span>{' '}
                <span className="mr-[4px]">ASSOCIATION</span>
              </h2>
            </div>
          </a>
          <div className="text-center">
            <h3 className="uppercase text-black text-[16px]">
              <Trans>Chào mừng đến với</Trans>
              <span className="text-luat_HN_primary">
                &nbsp;Đoàn Luật sư Thành phố Hà Nội
              </span>
            </h3>
          </div>
        </div>
      </div>
      {children}
    </div>
  );
};

export default AuthLayoutSignup;
